"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ServiceManageMent_1 = __importDefault(require("./ServiceManageMent"));
const Merchant_1 = __importDefault(require("./Merchant"));
const Webhook_1 = __importDefault(require("./Webhook"));
const ServiceMember_1 = __importDefault(require("./ServiceMember"));
const ActivityLog_1 = __importDefault(require("./ActivityLog"));
const RuntimeConfig_1 = __importDefault(require("./RuntimeConfig"));
const APIKey_1 = __importDefault(require("./APIKey"));
const MailSubscription_1 = __importDefault(require("./MailSubscription"));
const Upload_1 = __importDefault(require("./Upload"));
const Company_1 = __importDefault(require("./Company"));
const Usage_1 = __importDefault(require("./Usage"));
const ServiceBilling_1 = __importDefault(require("./ServiceBilling"));
const Plan_1 = __importDefault(require("./Plan"));
const KYBServiceManagement_1 = __importDefault(require("./KYBServiceManagement"));
const KYBServiceMember_1 = __importDefault(require("./KYBServiceMember"));
const AdminTool_1 = __importDefault(require("./AdminTool"));
const ServiceEncryptionKey_1 = __importDefault(require("./ServiceEncryptionKey"));
class AdminConsoleAPIV2 {
    constructor(httpClient) {
        this.serviceManagementAPI = new ServiceManageMent_1.default(httpClient);
        this.merchantProfileAPI = new Merchant_1.default(httpClient);
        this.webhookAPI = new Webhook_1.default(httpClient);
        this.memberAPI = new ServiceMember_1.default(httpClient);
        this.activityLogAPI = new ActivityLog_1.default(httpClient);
        this.runtimeConfigAPI = new RuntimeConfig_1.default(httpClient);
        this.apiKeyAPI = new APIKey_1.default(httpClient);
        this.mailSubscriptionAPI = new MailSubscription_1.default(httpClient);
        this.uploadAPI = new Upload_1.default(httpClient);
        this.companyAPI = new Company_1.default(httpClient);
        this.usageAPI = new Usage_1.default(httpClient);
        this.serviceBillingAPI = new ServiceBilling_1.default(httpClient);
        this.planAPI = new Plan_1.default(httpClient);
        this.kybServiceManagementAPI = new KYBServiceManagement_1.default(httpClient);
        this.kybServiceMemberAPI = new KYBServiceMember_1.default(httpClient);
        this.adminTool = new AdminTool_1.default(httpClient);
        this.serviceEncryptionKeyAPI = new ServiceEncryptionKey_1.default(httpClient);
    }
}
exports.default = AdminConsoleAPIV2;
